import { Tooltip } from '@mantine/core';
import {
  IconChecks,
  IconHourglassHigh,
  IconAlertTriangle,
} from '@tabler/icons-react';

export type NccVerifiedStatus = boolean | null | undefined;

const getStatusConfig = (nccVerified: NccVerifiedStatus) => {
  if (nccVerified === true) {
    return {
      icon: IconChecks,
      color: 'var(--mantine-color-green-6)',
      label: 'Подтвержден',
    };
  }

  if (nccVerified === false) {
    return {
      icon: IconAlertTriangle,
      color: 'var(--mantine-color-red-6)',
      label: 'Не подтвержден',
    };
  }

  return {
    icon: IconHourglassHigh,
    color: 'var(--mantine-color-yellow-6)',
    label: 'Не проверено',
  };
};

type NccVerifiedStatusIconProps = {
  nccVerified: NccVerifiedStatus;
  size?: number;
};

export const NccVerifiedStatusIcon = ({
  nccVerified,
  size = 20,
}: NccVerifiedStatusIconProps) => {
  const { icon: Icon, color, label } = getStatusConfig(nccVerified);

  return (
    <Tooltip label={label} withArrow>
      <Icon size={size} color={color} style={{ flexShrink: 0 }} />
    </Tooltip>
  );
};

export const getNccVerifiedStatusLabel = (
  nccVerified: NccVerifiedStatus
): string => getStatusConfig(nccVerified).label;
